import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-449395c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-page__title" }
const _hoisted_3 = { class: "login-page__container" }
const _hoisted_4 = { class: "login-page__input-wrapper" }
const _hoisted_5 = { class: "login-page__input-group" }
const _hoisted_6 = {
  class: "label",
  id: "login.emailAddress"
}
const _hoisted_7 = { class: "login-page__input-group" }
const _hoisted_8 = {
  class: "label",
  id: "login.password"
}
const _hoisted_9 = { class: "button-group" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "login-page__login-links" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_message = _resolveComponent("v-message")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("LoginPage.Login")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_form, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Common.EmailAddress")), 1),
              _createVNode(_component_v_field, {
                name: "emailAddress",
                type: "email",
                id: "login.emailAddress",
                class: "input form-control",
                modelValue: _ctx.emailAddress,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailAddress) = $event)),
                rules: "required|email",
                label: _ctx.$t('Common.EmailAddress'),
                placeholder: _ctx.$t('ContactForm.EmailPlaceholder')
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, {
                for: "login.emailAddress",
                name: "emailAddress"
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("Common.Password")), 1),
              _createVNode(_component_v_field, {
                name: "password",
                type: "password",
                id: "login.password",
                class: "input form-control",
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                rules: "required",
                label: _ctx.$t('Common.Password'),
                placeholder: _ctx.$t('LoginPage.PasswordPlaceholder')
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, {
                for: "login.password",
                name: "password"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BaseButton, {
              class: "button--primary button--base",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("LoginPage.Login")), 1)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("p", {
            class: "error-message",
            innerHTML: _ctx.errorMessage
          }, null, 8, _hoisted_10), [
            [_vShow, _ctx.hasError]
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: _ctx.baseUrl + _ctx.forgottenpasswordurl
              }, _toDisplayString(_ctx.$t("LoginPage.ForgottenPassword")), 9, _hoisted_12)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: _ctx.baseUrl + _ctx.registerurl + '?redir='+_ctx.pathUrl
              }, _toDisplayString(_ctx.$t("LoginPage.RegisterUserLinkText")), 9, _hoisted_13)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}